import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function ExternalLinkIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 19 20"
        {...props}
      >
        <path d="M17.95 20H1.06C.48 20 0 19.54 0 18.97V1.19c0-.05-.01-.1 0-.16C0 .32.32.1 1.08.03V0c.05 0 .1 0 .15.01C1.74 0 2.34 0 3.44 0h6.67v2.08H2.1v15.86h14.8V8.46h2.09v10.5c0 .57-.47 1.03-1.05 1.03z" />
        <path d="M19 1.37v4.05h-2.09V3.38l-7.89 8.47-1.54-1.4 7.76-8.33h-2.29V.06h4.72C18.4.06 19 .64 19 1.37" />
      </svg>
    </Icon>
  )
}
export default ExternalLinkIcon
